import { AppState } from 'src/redux/store';
import {
  selectThreadDetailOp,
  selectPostById,
  threadDetailActions,
} from 'src/redux/slices/threadDetailSlice';
import { PostErrors, PostState } from 'src/types/DiscussionPost';
import { useAppSelector, useAppDispatch } from 'src/redux/hooks';
import ActionType from './types';

export default function usePostLevelValidators(additionalParams: { [key: string]: string }) {
  const { postId } = additionalParams;
  const dispatch = useAppDispatch();
  const post = useAppSelector((state: AppState) => selectPostById(state, postId))!;
  const opPost = useAppSelector(selectThreadDetailOp);
  const { userId } = useAppSelector(({ userInfo }: AppState) => userInfo);

  let isAuthor: boolean;
  if (post) {
    isAuthor = post && post.postDetails.userId === userId;
  }

  const POST_LEVEL_VALIDATORS = [
    () => {
      if (post && post.postDetails.isDeleted && postId) {
        dispatch(
          threadDetailActions.setError({ postId, postError: PostErrors.actionOnDeletedPost }),
        );
        return true;
      }
      return false;
    },
    (action?: ActionType) => {
      const allUsers = true;
      if (opPost && opPost.postState === PostState.closed && postId) {
        switch (true) {
          case action === ActionType.POST_FLAG && allUsers:
          case action === ActionType.POST_DELETE && isAuthor:
          case action === ActionType.POST_VOTE && allUsers:
            // no Operation
            return false;
          default:
            dispatch(threadDetailActions.setError({ postId, postError: PostErrors.lockedPost }));
            return true;
        }
      }
      return false;
    },
    (action?: ActionType) => {
      const allUsers = true;
      if (opPost && postId && opPost.isLocked) {
        switch (true) {
          case action === ActionType.POST_FLAG && allUsers:
          case action === ActionType.POST_DELETE && isAuthor:
          case action === ActionType.POST_VOTE && allUsers:
            // no Operation
            return false;
          default:
            dispatch(threadDetailActions.setError({ postId, postError: PostErrors.lockedPost }));
            return true;
        }
      }
      return false;
    },
  ];

  return POST_LEVEL_VALIDATORS;
}
